import React from "react";

import CompanyLogos from "./CompanyLogos";
import TestimonialPane from "./TestimonialPane";

import styles from "../css/Auth.module.css";

export default function TemplatePane() {
	const { template } = window.INITIAL_STATE;
	if (!template) return <TestimonialPane />;

	const { title, external_image: image, author_info: author } = template;
	return (
		<div className={styles.authPane}>
			<div className={styles.templatePane}>
				<div className={styles.shiftedUp}>
					<h2>
						<span className={styles.emphasis}>“{title}”</span>
					</h2>
					{author && (
						<div className={styles.templateAuthor}>
							<img
								src={author.type === "person" ? author.image : author.type === "company" ? author.logo : author.icon}
								alt="Template author portrait"
								title={author.name}
								/* @ts-ignore */
								onError={e => (e.target.style.display = "none")}
							/>
							<div>
								<div>Template by {author.name}</div>
							</div>
						</div>
					)}
				</div>
				<div className={styles.shiftedCenter}>
					<div className={styles.templateImage}>
						<div>
							<img
								src={image}
								alt="Screenshot of template"
								title={title}
								/* @ts-ignore */
								onError={e => (e.target.style.display = "none")}
							/>
						</div>
					</div>
				</div>
				<CompanyLogos />
			</div>
		</div>
	);
}
